import { FormCreaUtente } from "./FormCreaUtente/FormCreaUtente";
import CaricamentoMultiplo from "./CaricamentoMultiplo/CaricamentoMultiplo";
import { useLocation, useNavigate } from "react-router-dom";
import { t } from "i18next";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack";

const CreaUtentePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex w-full items-center">
        <CoreBack />
        <h2 className="font-bold">
          {t("Create")} {location?.state?.operator ? t("operator") : t("user")}
        </h2>
      </div>

      <div className="flex">
        <div className="w-1/2 pr-28">
          <FormCreaUtente
            onClose={() => navigate(-1)}
            isOperator={location?.state?.operator}
          />
        </div>
        <div className="w-1/2">
          <CaricamentoMultiplo isOperator={location?.state?.operator} />
        </div>
      </div>
    </div>
  );
};

export default CreaUtentePage;
